import { SearchState } from "./SearchState";
import { useSearchStore } from "./useSearchStore";

export function useSearchState(): SearchState {
    return useSearchStore()[0];
}
